import { Product } from '@axo/shared/data-access/types';
import { addTranslationBundle } from '@axo/shared/i18n';
import { Card } from '@axo/ui-core/components/Card';
import { SectionLayout } from '@axo/ui-core/components/layout/section';
import * as Sentry from '@sentry/browser';
import { FormStepsIndicator } from '../../../../components/ProgressIndicator/FormStepsIndicator';
import { useAxoFormContext } from '../../../../context/AxoForm/AxoForm';
import { FormGlobalProviders } from '../../../../providers/FormGlobalProviders';
import type { FormProps } from '../../../../types';
import type { FinlandFormData } from '../../FormData.fi.types';
import { Aside } from '../Aside';
import { fi, mutators, steps } from '../config';
import styles from '../loan.module.scss';

const product = Product.UnsecuredLoan;

addTranslationBundle({ [product]: { fi } });

const Form = (props: FormProps) => {
  Sentry.setTag('axo-form', 'v2');
  Sentry.setTag('country', 'fi');
  Sentry.setTag('product', product);

  const { StepComponent } = useAxoFormContext<FinlandFormData>();

  return (
    <Card variant="default" className={styles.formContainer}>
      <FormStepsIndicator />
      <StepComponent {...props} />
    </Card>
  );
};

export function Main(props: FormProps) {
  return (
    <FormGlobalProviders
      product={product}
      axoFormOptions={{
        mutators,
        steps,
        ...props,
      }}
    >
      {/* TODO: Move Layout + Aside to Site-One */}
      <SectionLayout layout={'responsive'} type={'app'}>
        <SectionLayout.Content>
          <Form {...props} />
        </SectionLayout.Content>
        <SectionLayout.Aside position="right" order="bottom">
          <Aside isWL={props.isWL} />
        </SectionLayout.Aside>
      </SectionLayout>
    </FormGlobalProviders>
  );
}

export default Main;
